import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, shareReplay, startWith, tap, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectProfileIdentityName } from '../../../store/profile/profile.state';
import { selectRouteParam } from '../../../store/router/router.state';
import { shipmentNumber } from '../../../utils/shipment-number';
import { Observable } from 'rxjs';
import { selectRouteTitle } from '../../../store/interface/interface.state';

@Injectable({
    providedIn: 'root'
})
export class TitleService {

    public title$: Observable<string>;

    constructor(private title: Title, private router: Router, private activatedRoute: ActivatedRoute, private store: Store<AppState>) {
        this.store.select(selectProfileIdentityName).subscribe(name => this.title.setTitle(name));
    }

}
